import { Sparkles, Linkedin, Twitter, Github } from 'lucide-react'
import { brand, footer } from '../data/site'

export default function Footer() {
  return (
    <footer className="border-t border-slate-100 bg-white">
      <div className="mx-auto max-w-6xl px-6 py-14">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          {/* brand */}
          <div className="lg:col-span-2">
            <a href="#top" className="flex items-center gap-2 font-semibold tracking-tight text-slate-900">
              <span className="grid h-9 w-9 place-items-center rounded-xl bg-gradient-to-br from-brand-500 to-brand-700 text-white">
                <Sparkles className="h-5 w-5" />
              </span>
              <span className="text-lg">{brand.name}</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-500">{footer.tagline}</p>
            <div className="mt-5 flex items-center gap-3">
              {[Linkedin, Twitter, Github].map((Icon, i) => (
                <a
                  key={i}
                  href="#top"
                  aria-label="Social link"
                  className="grid h-9 w-9 place-items-center rounded-lg bg-slate-50 text-slate-500 transition-colors hover:bg-brand-600 hover:text-white"
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          {/* link columns */}
          {footer.columns.map((col) => (
            <div key={col.heading}>
              <h3 className="text-sm font-semibold text-slate-900">{col.heading}</h3>
              <ul className="mt-4 space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-slate-500 transition-colors hover:text-brand-600"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-slate-100 pt-6 sm:flex-row">
          <p className="text-sm text-slate-400">
            © 2026 {brand.name}. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-slate-400">
            <a href="#top" className="transition-colors hover:text-brand-600">Privacy</a>
            <a href="#top" className="transition-colors hover:text-brand-600">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  )
}
